import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import ENDPOINTS from "@/constants/endpoints"

export type WhiteLabel = {
  uuid: string
  name: string
  slug: string
}

export const useWhiteLabels = () => {
  return useQuery({
    queryKey: ["white-labels"],
    queryFn: async () => {
      const { data } = await api.get<WhiteLabel[]>(
        ENDPOINTS.WHITE_LABELS
      )
      return data || []
    },
    staleTime: 1000 * 60 * 5, // 5 minutos
  })
}
